import Box from "@mui/material/Box";
import OptionButton from "./OptionButton";

const LEVELS = [1, 2, 3, 4, 5, 6, 7] as const;

const HSKLevelCheckboxes = ({
  filteredLevels,
  setFilteredLevels
}: {
  filteredLevels: number[];
  setFilteredLevels: (levels: number[]) => void;
}) => {
  const toggleLevel = (level: number) => {
    if (filteredLevels.includes(level)) {
      setFilteredLevels(filteredLevels.filter((entry) => entry !== level));
      return;
    }
    setFilteredLevels([level, ...filteredLevels]);
  };

  return (
    <Box
      role="group"
      aria-label="HSK level"
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
        gap: 1
      }}>
      {LEVELS.map((level) => (
        <OptionButton
          key={level}
          selected={filteredLevels.includes(level)}
          onClick={() => toggleLevel(level)}
          ariaLabel={level === 7 ? "HSK 7 and above" : `HSK level ${level}`}>
          {level === 7 ? "+" : level}
        </OptionButton>
      ))}
    </Box>
  );
};

export default HSKLevelCheckboxes;
